<template>
    <vk-offcanvas-content>
      <vk-button @click="show = !show" class="menu-trigger uk-margin-small-right">メニュー</vk-button>
      <vk-offcanvas :show.sync="show" style="text-align:center;">
        <ul class="links">
          <li :class="page=='design' ? 'active' : ''">
            <vk-button @click="setPage('design'); show = false; $router.push({name:'category'})">シミュレータ画面</vk-button>
          </li>
          <li :class="page=='manual' ? 'active' : ''">
            <vk-button @click="setPage('manual'); show = false; $router.push({name:'manual'})">はじめに</vk-button>
          </li>
          <li :class="page=='how-to' ? 'active' : ''">
            <vk-button @click="setPage('how-to'); show = false; $router.push({name:'how'})">使い方</vk-button>
          </li>
          <li :class="page=='Q&A' ? 'active' : ''">
            <vk-button @click="setPage('Q&A'); show = false; $router.push({name:'faq'})">注意事項</vk-button>
          </li>
          <!--<li :class="page=='notice' ? 'active' : ''">-->
            <!--<vk-button @click="setPage('notice'); show = false; $router.push({name:'faq'})">お知らせ</vk-button>-->
          <!--</li>-->
          <!--<li :class="page=='rule' ? 'active' : ''">-->
            <!--<vk-button @click="setPage('rule'); show = false; $router.push({name:'faq'})">注意事項</vk-button>-->
          <!--</li>-->
          <!--<li :class="page=='about-limit' ? 'active' : ''">-->
            <!--<vk-button @click="setPage('about-limit'); show = false; $router.push({name:'faq'})">納期について</vk-button>-->
          <!--</li>-->
          <li>
            <vk-button class="sns" @click="jump('https://www.facebook.com/Chapeu.net/')">
              <div>
                <img src="//uni-admin.chapeu.co.jp/img/facebook.png" alt="" style="width:1.2em; vertical-align: sub">
                Facebook
              </div>
            </vk-button>
          </li>
          <li>
            <vk-button class="sns" @click="jump('http://instagram.com/chapeu_for_footballer')">
              <div>
                <img src="//uni-admin.chapeu.co.jp/img/insta.png" alt="" style="width:1.2em; vertical-align: sub">
                Instagram
              </div>
            </vk-button>
          </li>
          <li>
            <vk-button class="sns" @click="jump('https://twitter.com/Chapeu_for_')">
              <div>
                <img src="//uni-admin.chapeu.co.jp/img/twitter.png" alt="" style="width:1.2em; vertical-align: sub">
                Twitter
              </div>
            </vk-button>
          </li>

          <li :class="page=='rule' ? 'active' : ''">
            <vk-button @click="setPage('rule'); show = false; $router.push({name:'rule'})">利用規約</vk-button>
          </li>
          <li :class="page=='policy' ? 'active' : ''">
            <vk-button @click="setPage('privacy'); show = false; $router.push({name:'privacy'})">プライバシーポリシー</vk-button>
          </li>
          <li :class="page=='law' ? 'active' : ''">
            <vk-button @click="setPage('law'); show = false; $router.push({name:'law'})">特定商取引法に基づく表記</vk-button>
          </li>

          <li>
            <vk-button class="sns" @click="jump('http://chapeu.co.jp/')">
              ChapeuWebサイト
            </vk-button>
          </li>
          <li>
            <vk-button class="sns" @click="allClear">
              シミュレータTOP(オールクリア)
            </vk-button>
          </li>
        </ul>
        <vk-button class="sns" @click="show = false"> 閉じる </vk-button>
      </vk-offcanvas>
    </vk-offcanvas-content>
</template>


<script>
  import {mapMutations} from 'vuex'
  import modal from '../../service/modal';

  export default {
    name: 'app-menu',
    components: {},
    data () {
      return {
        show: false,
      }
    },
    computed: {
      page(){ return this.$store.state.page; }
    },
    methods: {
      ...mapMutations([
        'setPage',
      ]),
      jump: function(url, win='_blank'){
        window.open(url, win);
      },
      allClear () {
        const self = this;
        modal.confirm({
          header: 'オールクリア確認',
          message: '編集中のデザイン及び、カート' +
            'の中⾝も全オールクリア確認' +
            'てリセットされます' +
            'がよろしいですか？',
          button: 'オールクリア',
          doSomething() {
            self.$store.commit('resetStockCart');
            self.$store.commit('resetCart');
            self.jump('/', '_self');
          }
        });
      }
    },
  }
</script>

<style scoped>
  .menu-trigger{
    border-radius: 3px;
    line-height: 25px;
    background-color: #fff;
    color: #151d66;
    padding: 0 10px;
    width: 96%;
  }
  ul.links{
    padding: 40px 0;
  }
  ul.links>li.active{
    background-color: #151d66;
  }
  ul.links>li>button{
    width: 100%;
    text-transform: none;
    color:#333;
    border-bottom:1px solid #aaa;
    text-align: left;
  }
  ul.links>li.active>button{
    color: white;
  }
  .uk-button.sns{
    color: black;
  }
  .uk-margin-small-right{
    float:left;
  }

</style>
<style>
  /**
  offcanvasでコンテンツが右側にずれるのを抑制
   */
  .uk-offcanvas-page-open{
    margin-left: 0 !important;
  }
  .uk-offcanvas-bar{
    padding: 0;
  }
</style>
